import { deleteAuthToken, deleteLoginTokenSucceed } from 'src/app/auth/cookies';
import Avo from 'src/tracking/Avo';

const removeUserInfo = (): void => {
  if (typeof window !== undefined) {
    Avo.logOutConfirmed({
      origin: window.location.pathname,
    });
  }

  deleteAuthToken();
  deleteLoginTokenSucceed();
};

export default removeUserInfo;
